/*
* @Author: zhengxiaowen
* @Date: 2018-09-21 09:21:53
* @Last Modified by: zhengxiaowen
* @Last Modified time: 2020-01-03 17:08:25
*/

import store from '../store/StoreCommon'
import service from './service'
import systemHook from '@/config/systemHook'
import jquery from 'jquery'
import Toast from 'vux/src/components/toast/index.vue'


let nativeApi = {}


nativeApi.createListen = function (_this) {
_this.$store.commit('SET_NATIVE_FLAG', true)
document.addEventListener('message', function (e) {

try {
let msg = {}
if(typeof e.data === 'object'){
msg = e.data
}else if(typeof e.data === 'string'){
msg = JSON.parse(e.data)
}

if (msg.nativeType === 'userInfo') {

if(systemHook && systemHook.appInitManageUserInfo){
systemHook.appInitManageUserInfo(_this,msg)
}else{




if(msg.data.userInfo) localStorage.setItem('userInfo', JSON.stringify(msg.data.userInfo))
if(msg.data.guideInfo) localStorage.setItem('guideInfo', JSON.stringify(msg.data.guideInfo))
if(msg.data.shopInfo) localStorage.setItem('shopInfo', JSON.stringify(msg.data.shopInfo))
if(msg.data.orgInfo) localStorage.setItem('orgInfo', JSON.stringify(msg.data.orgInfo))
if(msg.data.phoneInfo) localStorage.setItem('phoneInfo', JSON.stringify(msg.data.phoneInfo))
if(msg.data.webviewKey) localStorage.setItem('webviewKey', JSON.stringify(msg.data.webviewKey))



if(msg.data.warehouseCodeInfo) localStorage.setItem('warehouseCodeInfo', JSON.stringify(msg.data.warehouseCodeInfo))
if(msg.data.currentWarehouseCode) localStorage.setItem('currentWarehouseCode', JSON.stringify(msg.data.currentWarehouseCode))
if(msg.data.productInfo) localStorage.setItem('productInfo', JSON.stringify(msg.data.productInfo))
if(msg.data.subInvData) localStorage.setItem('subInvData', JSON.stringify(msg.data.subInvData))


if(msg.data.h5Header) sessionStorage.setItem('h5Header', JSON.stringify(msg.data.h5Header))

nativeApi.setUserInfo(_this)
}

} else if (msg.nativeType === 'geolocation' ||
msg.nativeType === 'barcodeScanner' ||
msg.nativeType === 'barcodeScannerS' ||
msg.nativeType === 'takePhoto' ||
msg.nativeType === 'barcodeScannerStore' ||
msg.nativeType === 'barcodeScannerForCss') {
let {nativeType, id, data} = msg
nativeApi.executeTransaction(nativeType, id, data)
} else if (msg.nativeType === 'keyboardDid') {
let {nativeType, id, data} = msg
service.updateKeyboardDid(data.status)
if(data.platform=='android'){
document.getElementsByClassName('content')[0].scrollTop = data.height;
}
}else if(msg.nativeType === 'webviewKey'){
let {nativeType, id, data} = msg
nativeApi.RNExecuteTransaction(nativeType, id, data)
}
} catch (error) {
alert('message 初始化异常'+error)
}
})
}


nativeApi.setUserInfo = function (_this) {
_this.$store.commit('INIT_USER_INFO')
_this.$store.commit('INIT_GUIDE_INFO')
_this.$store.commit('INIT_SHOP_INFO')
_this.$store.commit('INIT_ORG_INFO')
_this.$store.commit('INIT_PHONE_INFO')
_this.$store.commit('INIT_WEBVIEW_KEY')

_this.$store.commit('WAREHOUSE_CODE_INFO')
_this.$store.commit('CURRENT_WAREHOUSE_CODE')
_this.$store.commit('PRODUCT_INFO')
_this.$store.commit('SUB_INV_DATA')

_this.$store.commit('h5Header')















nativeApi.router(_this)
}


nativeApi.H5Init = function(_this){
_this.$store.commit('SET_NATIVE_FLAG', false)

nativeApi.setUserInfo(_this)

nativeApi.router(_this)
}


nativeApi.router = function (_this) {
try {
sessionStorage.removeItem('routerName')
let params = _this.$route.query.params ? JSON.parse(_this.$route.query.params) : {}
let query = _this.$route.query.query ? JSON.parse(_this.$route.query.query) : {}

if (_this.$route.query.url) {
_this.$router.push(_this.$route.query.url)
} else if(_this.$route.query.routerName){
sessionStorage.routerName = _this.$route.query.routerName
_this.$router.push({
name: _this.$route.query.routerName,
params: params,
query: query
})
}else if(_this.$route.query.routerPath){
_this.$router.push({
path: _this.$route.query.routerPath,
params: params,
query: query
})
}

} catch (error) {
alert('url参数配置有误')
}
jquery('#app-loading').css({display:"none"})

}



nativeApi.nativeFN = {}


nativeApi.nativeFN.setNav = function (data) {
let msg = {
nativeType: 'updateScene',
data: data
}
nativeApi.postMessage(msg)
}


nativeApi.nativeFN.setModalStatus = function (data) {
let msg = {
nativeType: 'updateModalStatus',
data: data
}
window.postMessage(JSON.stringify(msg))
}


nativeApi.nativeFN.barcodeScanner = function (fn) {
let msg = nativeApi.initParams('barcodeScanner', fn)
nativeApi.postMessage(msg)
}


nativeApi.nativeFN.barcodeScannerS = function (fn) {
let msg = nativeApi.initParams('barcodeScannerS', fn)
nativeApi.postMessage(msg)
}


nativeApi.nativeFN.barcodeScannerStore = function (data,fn) {
let msg = nativeApi.initParams('barcodeScannerStore', fn)
msg.data = data
nativeApi.postMessage(msg)
}


nativeApi.nativeFN.barcodeScannerForCss = function (data,fn) {
let msg = nativeApi.initParams('barcodeScannerForCss', fn)
msg.data = data
nativeApi.postMessage(msg)
}


nativeApi.nativeFN.takePhoto = function (fn) {
let msg = nativeApi.initParams('takePhoto', fn)
nativeApi.postMessage(msg)
}


nativeApi.nativeFN.geolocation = function (fn) {
let msg = nativeApi.initParams('geolocation', fn)
nativeApi.postMessage(msg)
}


nativeApi.nativeFN.logout = function () {
let msg = nativeApi.initParams('logout')
nativeApi.postMessage(msg)
}


nativeApi.nativeFN.phoneCall = function (number) {
window.location.href = 'tel:' + number
}


nativeApi.nativeFN.openWechat = function () {
let msg = {
nativeType: 'openApp',
data: {
appName: '微信',
appUrl: 'weixin://'
}
}
nativeApi.postMessage(msg)
}


nativeApi.nativeFN.closeWindow = function(){
let msg = {
nativeType: 'closeWindow',
data: {}
}
nativeApi.postMessage(msg)
}


nativeApi.nativeFN.rnRouter = function(data){
let msg = {
nativeType: 'rnRouter',
data: data
}
nativeApi.postMessage(msg)
}

nativeApi.nativeFN.shortMessage = function(data){
let msg = {
nativeType: 'shortMessage',
data: data
}
nativeApi.postMessage(msg)
}


nativeApi.nativeFN.rnRouterApproval = function(props){
let msg = {
nativeType: 'rnRouter',
data: {
url:'applyRecord',
props:props,
}
}
nativeApi.postMessage(msg)
}


nativeApi.nativeFN.docViewer = function(obj){

let msg ={
nativeType:'docViewer',
data:{
filePath:obj.filePath,
fileName:obj.fileName?obj.fileName:obj.sourceFileName,
fileType:obj.fileType
}
}
nativeApi.postMessage(msg)
}


nativeApi.nativeFN.downLoadImage = function (data,fn) {
let msg = nativeApi.initParams('downLoadImage', fn)
msg.data = data;
nativeApi.postMessage(msg)
}


nativeApi.nativeFN.FlowRetrial = function(){

let msg ={
nativeType:'FlowRetrial',
data:{}
}
nativeApi.postMessage(msg)
}


nativeApi.nativeFN.FlowStart = function(){
let msg ={
nativeType:'FlowStart',
data:{}
}
nativeApi.postMessage(msg)
}


nativeApi.nativeFN.completeDataStatus = function (payload) {
let msg = {
nativeType: 'completeDataStatus',
data: {
value:payload
}
}
nativeApi.postMessage(msg)
}





nativeApi.initParams = function (nativeType, fn) {
return {

id: fn ? nativeApi.addTransaction(nativeType, fn) : null,
data: null,
nativeType: nativeType
}
}


nativeApi.postMessage = function (msg) {
if (!store.state.system.isNative) {
return
}
window.postMessage(JSON.stringify(msg))
}


nativeApi.transactions = {}

nativeApi.addTransaction = function (nativeType, fn) {
const id = new Date().getTime()
nativeApi.transactions[`${nativeType}(${id})`] = fn
return id
}

nativeApi.executeTransaction = function (nativeType, id, data) {
if (nativeApi.transactions[`${nativeType}(${id})`]) {
nativeApi.transactions[`${nativeType}(${id})`](data)
delete transactions[`${nativeType}(${id})`]
}
}





nativeApi.initRnRunH5Function = function(funs){
for(let key in funs){
nativeApi.transactions[`webviewKey(${key})`] = funs[key]
}

}

nativeApi.RNExecuteTransaction = async function(nativeType, id, data){
if(nativeApi.transactions[`${nativeType}(${id})`]){
let data = await nativeApi.transactions[`${nativeType}(${id})`](data)
let msg = {
nativeType: 'webviewKey',
id:id,
data: data,
status: "S"
}
nativeApi.postMessage(msg)
}else{
let msg = {
nativeType: 'webviewKey',
id:id,
data: null,
status: "E"
}
nativeApi.postMessage(msg)
}
}




export default nativeApi



// WEBPACK FOOTER //
// ./src/common/tool/nativeApi.js